import '.in{display:inline-block;}.ssr-plugin'
import '.io{margin-top:1.5rem;}.ssr-plugin'
import '.aj{font-size:0.875rem;}.ssr-plugin'
import '.ip{color:var(--palette-blue-500);}.ssr-plugin'
import '.hb{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="in io aj ip hb"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
